(function () {
  'use strict';

  var lastAddToCartRect = null;

  var BEE_SVG = [
    '<svg viewBox="0 0 32 20" xmlns="http://www.w3.org/2000/svg" class="flying-bee" aria-hidden="true">',
      '<ellipse class="bee-wing bee-wing-l" cx="10" cy="6" rx="8" ry="5" fill="rgba(200,230,255,0.85)"/>',
      '<ellipse class="bee-wing bee-wing-r" cx="22" cy="6" rx="8" ry="5" fill="rgba(200,230,255,0.85)"/>',
      '<ellipse cx="16" cy="13" rx="9" ry="5.5" fill="#F5C518"/>',
      '<rect x="12" y="9" width="3" height="8" rx="1.2" fill="#222"/>',
      '<rect x="17" y="9" width="3" height="8" rx="1.2" fill="#222"/>',
      '<circle cx="25" cy="13" r="4.5" fill="#F5C518"/>',
      '<circle cx="26.5" cy="11.5" r="1.2" fill="#222"/>',
      '<path d="M7 13L3 13" stroke="#555" stroke-width="1.5" stroke-linecap="round"/>',
      '<path d="M23 8.5C22 6 23 3 25 2" stroke="#222" stroke-width="0.8" fill="none" stroke-linecap="round"/>',
      '<circle cx="25.5" cy="1.5" r="1" fill="#222"/>',
    '</svg>'
  ].join('');

  function getHiveRect() {
    var hive = document.querySelector('.beehive-cart-wrapper');
    return hive ? hive.getBoundingClientRect() : null;
  }

  function flyBeeToHive(sourceRect) {
    var targetRect = getHiveRect();
    if (!targetRect || !sourceRect) return;

    var bee = document.createElement('div');
    bee.className = 'bee-flyto';
    bee.innerHTML = BEE_SVG;

    var startX = sourceRect.left + sourceRect.width / 2 - 16;
    var startY = sourceRect.top + sourceRect.height / 2 - 10;

    bee.style.cssText = [
      'position:fixed',
      'z-index:99999',
      'width:32px',
      'height:20px',
      'pointer-events:none',
      'left:' + startX + 'px',
      'top:' + startY + 'px'
    ].join(';');

    document.body.appendChild(bee);

    var endX = targetRect.left + targetRect.width / 2 - 16;
    var endY = targetRect.top + targetRect.height / 2 - 10;

    // Arcing mid-point: wobble sideways, arc upward
    var wobble = (Math.random() * 100 - 50);
    var midX = (startX + endX) / 2 + wobble;
    var midY = Math.min(startY, endY) - 80;

    var animation = bee.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      {
        transform: 'translate(' + (midX - startX) + 'px,' + (midY - startY) + 'px) scale(1.2) rotate(-15deg)',
        opacity: 1,
        offset: 0.45
      },
      {
        transform: 'translate(' + (endX - startX) + 'px,' + (endY - startY) + 'px) scale(0.1) rotate(20deg)',
        opacity: 0
      }
    ], {
      duration: 900,
      easing: 'cubic-bezier(0.4, 0, 0.6, 1)',
      fill: 'forwards'
    });

    animation.onfinish = function () {
      bee.remove();
      pulseHive();
    };
  }

  function pulseHive() {
    var wrapper = document.querySelector('.beehive-cart-wrapper');
    if (!wrapper) return;
    wrapper.classList.remove('beehive-pulse');
    // Force reflow to restart animation
    void wrapper.offsetWidth;
    wrapper.classList.add('beehive-pulse');
    setTimeout(function () { wrapper.classList.remove('beehive-pulse'); }, 600);
  }

  function bounceCount() {
    var count = document.querySelector('.beehive-count');
    if (!count) return;
    count.classList.remove('beehive-count-bounce');
    void count.offsetWidth;
    count.classList.add('beehive-count-bounce');
    setTimeout(function () { count.classList.remove('beehive-count-bounce'); }, 500);
  }

  function watchCartCount() {
    document.querySelectorAll('.js-cart-count').forEach(function (el) {
      new MutationObserver(function () {
        bounceCount();
        if (lastAddToCartRect) {
          flyBeeToHive(lastAddToCartRect);
          lastAddToCartRect = null;
        }
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function bindAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest(
        '.AddtoCart, [name="add"], .product-form__submit, input[type="submit"].btn, button[type="submit"].btn'
      );
      if (!btn) return;
      lastAddToCartRect = btn.getBoundingClientRect();
    });

    // Also catch form submits (some themes use form submit instead of button click)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && (form.action || '').indexOf('/cart/add') !== -1) {
        var btn = form.querySelector('[type="submit"]');
        if (btn) lastAddToCartRect = btn.getBoundingClientRect();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    watchCartCount();
    bindAddToCart();
  });
})();
